/*
 * 数字补全不足补0
 * 如 12 补全 00012
 * */
const prefixInteger = (num, length) => {
  return (num / window.Math.pow(10, length)).toFixed(length).substr(2);
};

export default prefixInteger;
